module.exports = __webpack_public_path__ + "static/media/german-tricky-numbers.61630cb8.PNG";